import { render } from "./LegacyRadioGroup.vue?vue&type=template&id=16da4592&scoped=true"
import script from "./LegacyRadioGroup.vue?vue&type=script&lang=js"
export * from "./LegacyRadioGroup.vue?vue&type=script&lang=js"

import "./LegacyRadioGroup.vue?vue&type=style&index=0&id=16da4592&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16da4592"]])

export default __exports__